const countryList = [
    { text: 'Afghanistan', id: 'AF' },
    { text: 'Afrique du Sud', id: 'ZA' },
    { text: 'Albanie', id: 'AL' },
    { text: 'Algérie', id: 'DZ' },
    { text: 'Allemagne', id: 'DE' },
    { text: 'Andorre', id: 'AD' },
    { text: 'Angola', id: 'AO' },
    { text: 'Antigua-et-Barbuda', id: 'AG' },
    { text: 'Arabie saoudite', id: 'SA' },
    { text: 'Argentine', id: 'AR' },
    { text: 'Arménie', id: 'AM' },
    { text: 'Australie', id: 'AU' },
    { text: 'Autriche', id: 'AT' },
    { text: 'Azerbaïdjan', id: 'AZ' },
    { text: 'Bahamas', id: 'BS' },
    { text: 'Bahreïn', id: 'BH' },
    { text: 'Bangladesh', id: 'BD' },
    { text: 'Barbade', id: 'BB' },
    { text: 'Biélorussie', id: 'BY' },
    { text: 'Belgique', id: 'BE' },
    { text: 'Belize', id: 'BZ' },
    { text: 'Bénin', id: 'BJ' },
    { text: 'Bhoutan', id: 'BT' },
    { text: 'Bolivie', id: 'BO' },
    { text: 'Bosnie-Herzégovine', id: 'BA' },
    { text: 'Botswana', id: 'BW' },
    { text: 'Brésil', id: 'BR' },
    { text: 'Brunei', id: 'BN' },
    { text: 'Bulgarie', id: 'BG' },
    { text: 'Burkina Faso', id: 'BF' },
    { text: 'Burundi', id: 'BI' },
    { text: 'Cambodge', id: 'KH' },
    { text: 'Cameroun', id: 'CM' },
    { text: 'Canada', id: 'CA' },
    { text: 'Cap-Vert', id: 'CV' },
    { text: 'République centrafricaine', id: 'CF' },
    { text: 'Chili', id: 'CL' },
    { text: 'Chine', id: 'CN' },
    { text: 'Chypre (pays)', id: 'CY' },
    { text: 'Colombie', id: 'CO' },
    { text: 'Comores (pays)', id: 'KM' },
    { text: 'République du Congo', id: 'CG' },
    { text: 'République démocratique du Congo', id: 'CD' },
    { text: 'Corée du Sud', id: 'KR' },
    { text: 'Corée du Nord', id: 'KP' },
    { text: 'Costa Rica', id: 'CR' },
    { text: "Côte d'Ivoire", id: 'CI' },
    { text: 'Croatie', id: 'HR' },
    { text: 'Cuba', id: 'CU' },
    { text: 'Danemark', id: 'DK' },
    { text: 'Djibouti', id: 'DJ' },
    { text: 'République dominicaine', id: 'DO' },
    { text: 'Dominique', id: 'DM' },
    { text: 'Égypte', id: 'EG' },
    { text: 'Salvador', id: 'SV' },
    { text: 'Émirats arabes unis', id: 'AE' },
    { text: 'Équateur (pays)', id: 'EC' },
    { text: 'Érythrée', id: 'ER' },
    { text: 'Espagne', id: 'ES' },
    { text: 'Estonie', id: 'EE' },
    { text: 'États-Unis', id: 'US' },
    { text: 'Éthiopie', id: 'ET' },
    { text: 'Fidji', id: 'FJ' },
    { text: 'Finlande', id: 'FI' },
    { text: 'France', id: 'FR' },
    { text: 'Gabon', id: 'GA' },
    { text: 'Gambie', id: 'GM' },
    { text: 'Géorgie (pays)', id: 'GE' },
    { text: 'Ghana', id: 'GH' },
    { text: 'Grèce', id: 'GR' },
    { text: 'Grenade (pays)', id: 'GD' },
    { text: 'Guatemala', id: 'GT' },
    { text: 'Guinée', id: 'GN' },
    { text: 'Guinée-Bissau', id: 'GW' },
    { text: 'Guinée équatoriale', id: 'GQ' },
    { text: 'Guyana', id: 'GY' },
    { text: 'Haïti', id: 'HT' },
    { text: 'Honduras', id: 'HN' },
    { text: 'Hongrie', id: 'HU' },
    { text: 'Inde', id: 'IN' },
    { text: 'Indonésie', id: 'ID' },
    { text: 'Iran', id: 'IR' },
    { text: 'Irak', id: 'IQ' },
    { text: 'Irlande (pays)', id: 'IE' },
    { text: 'Islande', id: 'IS' },
    { text: 'Israël', id: 'IL' },
    { text: 'Italie', id: 'IT' },
    { text: 'Jamaïque', id: 'JM' },
    { text: 'Japon', id: 'JP' },
    { text: 'Jordanie', id: 'JO' },
    { text: 'Kazakhstan', id: 'KZ' },
    { text: 'Kenya', id: 'KE' },
    { text: 'Kirghizistan', id: 'KG' },
    { text: 'Kiribati', id: 'KI' },
    { text: 'Koweït', id: 'KW' },
    { text: 'Laos', id: 'LA' },
    { text: 'Lesotho', id: 'LS' },
    { text: 'Lettonie', id: 'LV' },
    { text: 'Liban', id: 'LB' },
    { text: 'Liberia', id: 'LR' },
    { text: 'Libye', id: 'LY' },
    { text: 'Liechtenstein', id: 'LI' },
    { text: 'Lituanie', id: 'LT' },
    { text: 'Luxembourg (pays)', id: 'LU' },
    { text: 'Macédoine du Nord', id: 'MK' },
    { text: 'Madagascar', id: 'MG' },
    { text: 'Malaisie', id: 'MY' },
    { text: 'Malawi', id: 'MW' },
    { text: 'Maldives', id: 'MV' },
    { text: 'Mali', id: 'ML' },
    { text: 'Malte', id: 'MT' },
    { text: 'Maroc', id: 'MA' },
    { text: 'Îles Marshall (pays)', id: 'MH' },
    { text: 'Maurice (pays)', id: 'MU' },
    { text: 'Mauritanie', id: 'MR' },
    { text: 'Mexique', id: 'MX' },
    { text: 'États fédérés de Micronésie (pays)', id: 'FM' },
    { text: 'Moldavie', id: 'MD' },
    { text: 'Monaco', id: 'MC' },
    { text: 'Mongolie', id: 'MN' },
    { text: 'Monténégro', id: 'ME' },
    { text: 'Mozambique', id: 'MZ' },
    { text: 'Birmanie', id: 'MM' },
    { text: 'Namibie', id: 'NA' },
    { text: 'Nauru', id: 'NR' },
    { text: 'Népal', id: 'NP' },
    { text: 'Nicaragua', id: 'NI' },
    { text: 'Niger', id: 'NE' },
    { text: 'Nigeria', id: 'NG' },
    { text: 'Norvège', id: 'NO' },
    { text: 'Nouvelle-Zélande', id: 'NZ' },
    { text: 'Oman', id: 'OM' },
    { text: 'Ouganda', id: 'UG' },
    { text: 'Ouzbékistan', id: 'UZ' },
    { text: 'Pakistan', id: 'PK' },
    { text: 'Palaos', id: 'PW' },
    { text: 'Panama', id: 'PA' },
    { text: 'Papouasie-Nouvelle-Guinée', id: 'PG' },
    { text: 'Paraguay', id: 'PY' },
    { text: 'Pays-Bas', id: 'NL' },
    { text: 'Pérou', id: 'PE' },
    { text: 'Philippines', id: 'PH' },
    { text: 'Pologne', id: 'PL' },
    { text: 'Portugal', id: 'PT' },
    { text: 'Qatar', id: 'QA' },
    { text: 'Roumanie', id: 'RO' },
    { text: 'Royaume-Uni', id: 'GB' },
    { text: 'Russie', id: 'RU' },
    { text: 'Rwanda', id: 'RW' },
    { text: 'Saint-Christophe-et-Niévès', id: 'KN' },
    { text: 'Saint-Marin', id: 'SM' },
    { text: 'Saint-Vincent-et-les-Grenadines', id: 'VC' },
    { text: 'Sainte-Lucie', id: 'LC' },
    { text: 'Salomon', id: 'SB' },
    { text: 'Samoa', id: 'WS' },
    { text: 'Sao Tomé-et-Principe', id: 'ST' },
    { text: 'Sénégal', id: 'SN' },
    { text: 'Serbie', id: 'RS' },
    { text: 'Seychelles', id: 'SC' },
    { text: 'Sierra Leone', id: 'SL' },
    { text: 'Singapour', id: 'SG' },
    { text: 'Slovaquie', id: 'SK' },
    { text: 'Slovénie', id: 'SI' },
    { text: 'Somalie', id: 'SO' },
    { text: 'Soudan', id: 'SD' },
    { text: 'Soudan du Sud', id: 'SS' },
    { text: 'Sri Lanka', id: 'LK' },
    { text: 'Suède', id: 'SE' },
    { text: 'Suisse', id: 'CH' },
    { text: 'Suritext', id: 'SR' },
    { text: 'Eswatini', id: 'SZ' },
    { text: 'Syrie', id: 'SY' },
    { text: 'Tadjikistan', id: 'TJ' },
    { text: 'Tanzanie', id: 'TZ' },
    { text: 'Tchad', id: 'TD' },
    { text: 'Tchéquie', id: 'CZ' },
    { text: 'Thaïlande', id: 'TH' },
    { text: 'Timor oriental', id: 'TL' },
    { text: 'Togo', id: 'TG' },
    { text: 'Tonga', id: 'TO' },
    { text: 'Trinité-et-Tobago', id: 'TT' },
    { text: 'Tunisie', id: 'TN' },
    { text: 'Turkménistan', id: 'TM' },
    { text: 'Turquie', id: 'TR' },
    { text: 'Tuvalu', id: 'TV' },
    { text: 'Ukraine', id: 'UA' },
    { text: 'Uruguay', id: 'UY' },
    { text: 'Vanuatu', id: 'VU' },
    { text: 'Venezuela', id: 'VE' },
    { text: 'Viêt Nam', id: 'VN' },
    { text: 'Yémen', id: 'YE' },
    { text: 'Zambie', id: 'ZM' },
    { text: 'Zimbabwe', id: 'ZW' }
  ]
  
  export default countryList
  